export function getTransporterIdsForCountrySelection(order) {
	let uniqueTransporterIds = order ? [...new Set(order.orderLines.map(e => e.transporterId))].filter(e => e) : [] //make a filter to remove undefined value
	let transporterIdsWithType4 = order ? [...new Set(order.orderLines.filter(e => e.transporterTypeId == 4).map(e => e.transporterId))] : []
	uniqueTransporterIds = uniqueTransporterIds.length > 1 ? transporterIdsWithType4 : uniqueTransporterIds
	return uniqueTransporterIds
}
